export var CHANGE_MAP_BBOX = 'map/changeMapBbox';
export var TOGGLE_LAYER_START = 'map/toggleLayer';
export var TOGGLE_LAYER_DONE = 'map/toggleLayerDone';
export var SELECT_MAP_VIEW_FILTER = 'map/selectMapViewFilter';
export var MAP_DRAW = 'map/mapDraw';